<div class="ft-panel-bg"></div>
<div class="ft-panel-content"><ng-content /></div>
